var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400.304,
    height: 360.881,
    viewBox: "0 0 400.304 360.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID",
    cx: 4.711,
    cy: 8.524,
    rx: 4.711,
    ry: 8.524,
    transform: "translate(677.663 191.965)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    d: "M712.258,192.574c10.419,1.78,10.419,15.194,0,16.973a2.683,2.683,0,0,1-.885,0c-10.419-1.779-10.419-15.193,0-16.973A2.682,2.682,0,0,1,712.258,192.574Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_404page.svg",
    "data-name": "404page.svg",
    transform: "translate(-522.848 -126.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M668.386,269.563l-.838-26.214s5.208,23.99,32.484,23.678c26.067-.3,25.591-21.136,25.591-21.136l.93,10.565v42.68l-17,69.624-21.712,2.754-24-95.173Z",
    fill: "#e4ebf3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M723.2,261.173a2.735,2.735,0,0,1-.314.558,14.963,14.963,0,0,1-1.033,1.52,22.4,22.4,0,0,1-4.856,4.7,27.937,27.937,0,0,1-9.07,4.259,32.022,32.022,0,0,1-12.235.846,39.869,39.869,0,0,1-11.753-3.537,51.006,51.006,0,0,1-8.585-5.173,59.4,59.4,0,0,1-5.2-4.307c-.591-.534-1.019-.983-1.317-1.276a2.792,2.792,0,0,1-.43-.476,2.789,2.789,0,0,1,.506.394l1.385,1.2c1.2,1.037,2.979,2.5,5.286,4.15a53.313,53.313,0,0,0,8.571,5.027,40.3,40.3,0,0,0,11.607,3.45,32.115,32.115,0,0,0,12.032-.79,28.251,28.251,0,0,0,8.974-4.085,23.807,23.807,0,0,0,4.913-4.512C722.673,261.886,723.148,261.14,723.2,261.173Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M704.269,484.935l-.393-123.722-35.134-90.3-1.181-27.175-21.408,16.191S614.982,367.21,614.5,363.491s-.011,121.444-.011,121.444Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M703.425,484.592c-.153,0-.278-27.879-.278-62.261s.125-62.267.278-62.267.279,27.872.279,62.267S703.579,484.592,703.425,484.592Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M646.466,277.6l4.345,3.289-3.055,20.015,51.287,53.719-46.581-61.167,3.97-15.857Z",
    fill: "#e4ebf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M706.192,422.624l-78.706-23.077-2.607-59.782L646.466,261s-51.457,25.672-54.958,42.008-11.942,56.049-12.842,84.752c-.8,25.665-.921,42.824,4.939,51.015,16.784,23.462,127.389,27.652,171.577-.033",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M700.032,355.928a2.024,2.024,0,0,1-.256-.289l-.707-.882-2.673-3.425-9.75-12.656-32-41.884-2.408-3.162-.081-.106.032-.13c1.376-5.478,2.708-10.789,3.98-15.854l.26.333-9.965-.014h-.255v-.254c.016-6.475.03-12.412.042-17.672v-.106l.083-.063L661.8,248.009l4.246-3.187,1.116-.818a2.545,2.545,0,0,1,.394-.262,2.768,2.768,0,0,1-.355.312l-1.079.867L661.95,248.2l-15.355,11.9.083-.169c.013,5.26.027,11.2.042,17.672l-.254-.255,9.965-.013h.343l-.083.334c-1.266,5.067-2.592,10.379-3.96,15.859l-.049-.236q1.2,1.568,2.409,3.162l31.868,41.982,9.609,12.764,2.591,3.488.662.915A2.01,2.01,0,0,1,700.032,355.928Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M735.119,255.277c-6.278-10.978-9.534-9.836-9.534-9.836l.328,3.913.006,8.223-2.974,35.278-19.069,76.659.393,115.421h72.08l8.972-140.894-.815-60.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M784.506,283.345s18.658,13.774,20.274,35.931c1.312,18,4.325,67.278,4.869,78.007.849,16.708-12.161,55.831-46.033,44.749-20.311-6.646-95.36-32.156-95.36-32.156l4.993-31.871,89.076,5.306,1.769-74.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M735.119,255.277c-6.278-10.978-9.534-9.836-9.534-9.836l.328,3.913.006,8.223-2.974,35.278-19.069,76.659.393,115.421h72.08l8.972-140.894-.815-60.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M784.506,283.345s18.658,13.774,20.274,35.931c1.312,18,4.325,67.278,4.869,78.007.849,16.708-12.161,55.831-46.033,44.749-20.311-6.646-95.36-32.156-95.36-32.156l4.993-31.871,89.076,5.306,1.769-74.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M672.234,381.675s-25.211-2.726-31.051-1.316c-5.611,1.354-13.6,8.219-13.6,8.219l.113,9.961,40.561,11.337Z",
    fill: "#f7eae8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M703.876,357.99a1.727,1.727,0,0,1,.111-.343l.379-.985c.358-.895.864-2.157,1.508-3.768l5.642-13.815,8.433-20.463c.8-1.917,1.591-3.917,2.582-5.871.95-1.974,2.072-3.907,3.229-5.863a128.757,128.757,0,0,1,8.005-11.553c1.454-1.877,2.92-3.7,4.436-5.454l-.05.284q-1.6-4.08-3.14-7.987l-.1-.265.27-.092,13.139-4.466-.135.367-14.9-24.872c-1.8-3.018-3.343-5.428-4.976-6.419a6.572,6.572,0,0,0-1.993-.807c-.479-.116-.732-.159-.729-.177a5.446,5.446,0,0,1,.747.1,6.223,6.223,0,0,1,2.058.75,9.041,9.041,0,0,1,2.527,2.451,44.421,44.421,0,0,1,2.62,3.941l15.076,24.778.162.266-.3.1-13.127,4.5.165-.356,3.151,7.983.061.156-.111.128c-1.5,1.735-2.964,3.561-4.411,5.429a130.422,130.422,0,0,0-7.98,11.5c-1.153,1.942-2.272,3.862-3.219,5.816-.986,1.934-1.773,3.907-2.583,5.83l-8.544,20.418-5.806,13.749c-.685,1.593-1.223,2.842-1.6,3.727l-.43.964A1.8,1.8,0,0,1,703.876,357.99Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M794.742,435.831a2.611,2.611,0,0,1-.313.33l-.958.932a28.212,28.212,0,0,1-4.094,3.105,27.654,27.654,0,0,1-7.495,3.141,30.313,30.313,0,0,1-10.734.683,34.193,34.193,0,0,1-6.145-1.3c-2.091-.666-4.185-1.484-6.4-2.263-4.4-1.6-9.122-3.259-14.091-5-9.939-3.481-20.9-7.207-32.448-10.995-23.1-7.588-44.162-13.983-59.427-18.541l-18.092-5.353-4.918-1.46-1.275-.394a2.773,2.773,0,0,1-.429-.152,2.823,2.823,0,0,1,.445.1l1.29.341,4.947,1.36c4.291,1.2,10.493,2.958,18.143,5.183,15.3,4.462,36.382,10.8,59.49,18.39,11.55,3.789,22.511,7.532,32.445,11.04,4.965,1.758,9.68,3.437,14.077,5.053,2.2.786,4.321,1.624,6.37,2.287a33.97,33.97,0,0,0,6.061,1.321,30.239,30.239,0,0,0,10.614-.594,27.977,27.977,0,0,0,7.459-3.024,30.625,30.625,0,0,0,4.13-3l.993-.888A2.82,2.82,0,0,1,794.742,435.831Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M627.7,398.717c-.018.117-1.415-.188-3.674-.1a16.9,16.9,0,0,0-3.9.643,17.994,17.994,0,0,0-4.385,2,20.423,20.423,0,0,0-6.1,6.266c-1.2,1.925-1.711,3.25-1.81,3.208a3.408,3.408,0,0,1,.3-.953,17.005,17.005,0,0,1,1.175-2.458,19.13,19.13,0,0,1,6.134-6.533,17.413,17.413,0,0,1,4.546-2.023,15.749,15.749,0,0,1,4.023-.543,13.289,13.289,0,0,1,2.717.243A3.5,3.5,0,0,1,627.7,398.717Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M602.9,390.907c-.017-.009.017-.1.1-.282a2.714,2.714,0,0,1,.494-.7,5.055,5.055,0,0,1,2.8-1.389,14.271,14.271,0,0,1,4.622.01,26.656,26.656,0,0,1,5.483,1.333,24.059,24.059,0,0,1,8.7,5.323,18.569,18.569,0,0,1,2.016,2.359,4.442,4.442,0,0,1,.584.977c-.089.066-.97-1.3-2.871-3.051a25.775,25.775,0,0,0-8.614-5.084,28.122,28.122,0,0,0-5.366-1.348,14.791,14.791,0,0,0-4.482-.131,5.136,5.136,0,0,0-2.714,1.156C603.126,390.56,602.949,390.935,602.9,390.907Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M632.285,322.247a9.683,9.683,0,0,1-.359-1.623c-.159-.507-.392-1.117-.634-1.83-.342-.674-.676-1.47-1.165-2.285a32.325,32.325,0,0,0-4.013-5.337,42.951,42.951,0,0,0-6.147-5.407,36.983,36.983,0,0,0-13.439-6.173,27.876,27.876,0,0,0-4.475-.569,9.715,9.715,0,0,1-1.664-.136,9.6,9.6,0,0,1,1.669-.081,23.448,23.448,0,0,1,4.547.4,35.345,35.345,0,0,1,13.688,6.107,41.238,41.238,0,0,1,6.2,5.513,30.611,30.611,0,0,1,3.977,5.49c.475.842.792,1.667,1.111,2.363.221.74.427,1.371.556,1.9A9.43,9.43,0,0,1,632.285,322.247Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M764.727,343.925c.153,0,.278,8.628.278,19.268s-.125,19.27-.278,19.27-.279-8.626-.279-19.27S764.573,343.925,764.727,343.925Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M592.128,300.012s-.067.243-.22.71-.418,1.15-.643,2.086c-.52,1.852-1.178,4.619-1.916,8.222-1.489,7.2-3.323,17.746-5.379,30.943-1.021,6.6-2.11,13.864-3.18,21.714-.545,3.92-.882,8.008-1.166,12.238s-.505,8.6-.668,13.094c-.325,8.99-.516,18.486-.256,28.379.075,2.472.166,4.971.373,7.482.063,1.263.269,2.5.424,3.758a30.121,30.121,0,0,0,.912,3.691,21.043,21.043,0,0,0,3.542,6.772,15.284,15.284,0,0,0,6.081,4.683l.034.013.011.006a92.621,92.621,0,0,0,15.853,6.055c5.527,1.655,11.237,2.991,17.037,4.184a234.612,234.612,0,0,0,38.28,4.661,177.856,177.856,0,0,0,18.274-.476c5.954-.411,11.758-1.034,17.373-1.867a183.208,183.208,0,0,0,31.181-7.248,159.874,159.874,0,0,0,25.212-10.818l.027.347L718.726,426.4l-9.313-3.326-2.408-.874c-.541-.2-.813-.314-.813-.314s.284.08.831.263l2.426.824,9.346,3.231,34.646,12.082.407.142-.38.2a159.253,159.253,0,0,1-25.25,10.914,182.871,182.871,0,0,1-31.25,7.321c-5.628.843-11.443,1.473-17.409,1.892a178.458,178.458,0,0,1-18.328.492,234.3,234.3,0,0,1-38.375-4.66c-5.814-1.2-11.538-2.536-17.083-4.2a92.905,92.905,0,0,1-15.955-6.1l.044.019a15.759,15.759,0,0,1-6.333-4.863,21.572,21.572,0,0,1-3.63-6.948,30.678,30.678,0,0,1-.926-3.765c-.158-1.275-.366-2.544-.427-3.807-.205-2.525-.294-5.03-.367-7.508-.249-9.913-.043-19.415.3-28.412q.257-6.748.7-13.106c.294-4.233.642-8.336,1.2-12.266,1.091-7.852,2.2-15.113,3.247-21.711,2.1-13.194,3.994-23.73,5.543-30.928.768-3.6,1.457-6.363,2.009-8.209.241-.933.534-1.611.692-2.076S592.128,300.012,592.128,300.012Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M627.582,391.329c13.16-14.572,12.582-40.484,5.029-58.87-.7,19.918-3.047,37.58-4.847,56.935",
    fill: "#e4ebf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M632.639,336.19a2.82,2.82,0,0,1-.005.638l-.118,1.819c-.13,1.653-.308,3.917-.525,6.682l-1.815,22.036c-.672,8.576-1.28,16.337-1.727,22.045-.209,2.765-.379,5.03-.5,6.682l-.157,1.816a2.742,2.742,0,0,1-.093.631,2.773,2.773,0,0,1-.019-.637c.014-.478.031-1.081.053-1.823.053-1.582.169-3.869.327-6.7.323-5.652.863-13.454,1.565-22.064s1.417-16.394,1.978-22.026c.29-2.759.528-5.019.7-6.667.091-.737.164-1.336.223-1.809A2.724,2.724,0,0,1,632.639,336.19Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M665.085,309.862c.154,0,.278,5.059.278,11.3s-.124,11.3-.278,11.3-.279-5.058-.279-11.3S664.931,309.862,665.085,309.862Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M656.511,347.4a11.571,11.571,0,0,0,2.422,5.993c1.236,1.607,3.751,3.18,5.775,3.065a8.8,8.8,0,0,0,7.771-3.9c2.463-3.922,3.071-12.079,1.095-16.9-1.358-3.317-4.41-6.4-7.993-6.485-4.7-.111-7.653,3.288-8.658,6.728",
    fill: "#e4ebf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M656.923,335.9a7.172,7.172,0,0,1,.871-2.306,9.474,9.474,0,0,1,1.765-2.314,8.207,8.207,0,0,1,3.329-1.955,8.383,8.383,0,0,1,2.237-.358,6.792,6.792,0,0,1,2.448.322,9.638,9.638,0,0,1,4.367,3.132,12.6,12.6,0,0,1,2.568,5.347,23.057,23.057,0,0,1,.477,6.336c-.217,3.349-.874,6.681-2.728,9.228a8.268,8.268,0,0,1-3.55,2.677,9.65,9.65,0,0,1-4.018.676h.032a6.044,6.044,0,0,1-2.88-.714,9.491,9.491,0,0,1-2.166-1.51,10.78,10.78,0,0,1-2.359-3.515,10.347,10.347,0,0,1-.747-2.6,6.565,6.565,0,0,1-.067-.705c-.006-.16,0-.243.009-.244a14.462,14.462,0,0,0,1.043,3.439,10.828,10.828,0,0,0,2.37,3.35,9.221,9.221,0,0,0,2.1,1.41,5.665,5.665,0,0,0,2.671.631h.033a8.553,8.553,0,0,0,7.107-3.22c1.726-2.385,2.389-5.661,2.594-8.937.23-4.23-.479-8.492-2.886-11.329a9.233,9.233,0,0,0-4.114-3.017,6.388,6.388,0,0,0-2.293-.331,8.025,8.025,0,0,0-5.366,2.111,9.716,9.716,0,0,0-1.788,2.194A19.886,19.886,0,0,0,656.923,335.9Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M654.007,347.614a11.574,11.574,0,0,0,2.422,5.993c1.237,1.607,3.752,3.18,5.776,3.064a8.8,8.8,0,0,0,7.771-3.9c2.463-3.922,3.07-12.078,1.095-16.9-1.358-3.317-4.41-6.4-7.993-6.485-4.7-.112-7.653,3.288-8.658,6.728",
    fill: "#e4ebf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M654.42,336.114a7.181,7.181,0,0,1,.87-2.306,9.5,9.5,0,0,1,1.765-2.314,8.2,8.2,0,0,1,3.33-1.955,8.382,8.382,0,0,1,2.237-.358,6.762,6.762,0,0,1,2.447.322,9.633,9.633,0,0,1,4.368,3.132A12.592,12.592,0,0,1,672,337.982a23.021,23.021,0,0,1,.478,6.336c-.217,3.349-.875,6.681-2.728,9.228a8.265,8.265,0,0,1-3.55,2.676,9.637,9.637,0,0,1-4.018.676h.032a6.041,6.041,0,0,1-2.88-.714,9.441,9.441,0,0,1-2.166-1.511,10.769,10.769,0,0,1-2.359-3.515,10.286,10.286,0,0,1-.747-2.6,6.624,6.624,0,0,1-.068-.7.7.7,0,0,1,.009-.244,14.518,14.518,0,0,0,1.043,3.439,10.872,10.872,0,0,0,2.37,3.35,9.251,9.251,0,0,0,2.1,1.41,5.675,5.675,0,0,0,2.671.631h.032a8.556,8.556,0,0,0,7.108-3.219c1.725-2.385,2.389-5.662,2.594-8.937.23-4.231-.48-8.493-2.887-11.329a9.224,9.224,0,0,0-4.113-3.017,6.345,6.345,0,0,0-2.293-.331,8.01,8.01,0,0,0-5.366,2.111,9.747,9.747,0,0,0-1.789,2.193A19.91,19.91,0,0,0,654.42,336.114Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M658.546,334.911a5.505,5.505,0,0,0-5.742,3.308,9.492,9.492,0,0,0,.013,6.978,8.65,8.65,0,0,0,1.78,3.144,4.7,4.7,0,0,0,3.19,1.551,5.554,5.554,0,0,0,4.415-2.609,9.957,9.957,0,0,0,1.508-8.2c-.488-1.854-1.853-3.755-3.769-3.8",
    fill: "#e4ebf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M659.941,335.276a1.013,1.013,0,0,1,.425-.012,2.981,2.981,0,0,1,1.16.393,5.688,5.688,0,0,1,2.446,3.681,10.107,10.107,0,0,1-.66,6.545,8.527,8.527,0,0,1-2.4,3.146,4.631,4.631,0,0,1-4.126.988,5.746,5.746,0,0,1-3.3-2.694,12.047,12.047,0,0,1-1.373-3.694,8.22,8.22,0,0,1,1.068-6.459,5.74,5.74,0,0,1,3.73-2.372,4.078,4.078,0,0,1,1.22,0c.274.058.413.1.409.116a7.938,7.938,0,0,0-1.591.1,5.683,5.683,0,0,0-3.447,2.386,7.926,7.926,0,0,0-.887,6.129,11.757,11.757,0,0,0,1.338,3.514,5.242,5.242,0,0,0,2.978,2.441,4.1,4.1,0,0,0,3.643-.882,8.1,8.1,0,0,0,2.267-2.934,9.876,9.876,0,0,0,.741-6.24,5.622,5.622,0,0,0-2.176-3.583A4.5,4.5,0,0,0,659.941,335.276Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M663.939,352.488c-.085.021-.2-.336-.569-.766a3.984,3.984,0,0,0-1.825-1.17,10.061,10.061,0,0,0-2.245-.349c-.6-.043-.974-.092-.977-.17s.365-.166.974-.223a6.321,6.321,0,0,1,2.415.211,3.546,3.546,0,0,1,1.979,1.473C664.025,352.059,664,352.481,663.939,352.488Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M664.779,333.454c.049.048-.165.382-.663.776a5.32,5.32,0,0,1-4.71.851c-.6-.2-.921-.434-.892-.495a8.034,8.034,0,0,0,6.265-1.132Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M738.252,256.863c.008-.017.129.028.352.129a10.339,10.339,0,0,1,.951.491,19.425,19.425,0,0,1,3.2,2.291,23,23,0,0,1,6.884,10.89,69.717,69.717,0,0,1,2.62,12.678c.185,1.646.286,2.982.348,3.906a7.047,7.047,0,0,1,.027,1.44,7.238,7.238,0,0,1-.243-1.419l-.522-3.877a81.888,81.888,0,0,0-2.764-12.57,23.686,23.686,0,0,0-6.613-10.755A36.477,36.477,0,0,0,738.252,256.863Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M724.934,374.564c3.1-.119,5.575-3.209,8.672-3.043a4.309,4.309,0,1,1-.727,8.583c-3.253-.378-5.157-4.191-8.349-4.924",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M751.214,377.2a18.477,18.477,0,0,1-2.9-.241l.169-1.056c3.831.615,7.046-.016,9.563-1.866,3.165-2.326,5.2-6.487,6.062-12.367l.034-.224c.35-2.33.833-48.065.834-56.747,0-13.562-11.9-15.414-12.411-15.486-.482-.089-11.3-1.9-17.045,12.917-6.012,15.513-15.622,45.407-16.258,48.911-.079.429-.2.961-.334,1.577-1,4.486-3.078,13.82,3.148,19.2,6.94,5.993,12.413,3.674,12.642,3.574l.439.975c-.256.113-6.3,2.724-13.781-3.74-6.709-5.794-4.536-15.55-3.492-20.238.134-.6.25-1.117.325-1.535.641-3.532,10.287-33.553,16.315-49.106,6.073-15.675,18.094-13.611,18.214-13.586s13.309,2.036,13.307,16.541c0,7.153-.475,54.431-.846,56.9l-.033.221c-.9,6.173-3.083,10.572-6.488,13.073A12.284,12.284,0,0,1,751.214,377.2Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M765.509,313.451a19.929,19.929,0,0,0-2.226-5.33,18.135,18.135,0,0,0-11.094-7.821,20.1,20.1,0,0,0-13.536,1.765,23.86,23.86,0,0,0-4.706,3.371c-.014-.013.07-.125.244-.328a9.14,9.14,0,0,1,.8-.853,16.153,16.153,0,0,1,3.476-2.537,19.883,19.883,0,0,1,13.849-1.961,18.279,18.279,0,0,1,7.054,3.382,17.729,17.729,0,0,1,4.248,4.775,14.193,14.193,0,0,1,1.649,3.979,8.349,8.349,0,0,1,.216,1.15A1.152,1.152,0,0,1,765.509,313.451Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M792.738,398.934a36.654,36.654,0,0,0-1.466-4.562,19.935,19.935,0,0,0-7.254-8.7,15.666,15.666,0,0,0-5.886-2.123c-1.926-.321-3.694-.436-5.178-.538l-3.522-.243a5.779,5.779,0,0,1-1.287-.176,5.847,5.847,0,0,1,1.3-.041l3.531.067a44.006,44.006,0,0,1,5.242.425,15.662,15.662,0,0,1,6.1,2.16,19.385,19.385,0,0,1,7.317,9.021,17.161,17.161,0,0,1,.976,3.417A4.854,4.854,0,0,1,792.738,398.934Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M738.8,381.086s10.514-15.926,13.2-18.013,25.637-12.448,28.325-10.782,1.034,5.281,1.034,5.281,9.717-3.4,10.751-2.062a4.805,4.805,0,0,1,0,5.476s5.375-.827,5.375.827a6.807,6.807,0,0,1-3.1,5.583c-2.481,1.86-18.613,12.6-19.908,15.566l-5.225-.317Z",
    fill: "#e4ebf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M769.062,376.532a3.789,3.789,0,0,1,.48-1,18.568,18.568,0,0,1,1.728-2.49,28.944,28.944,0,0,1,7.626-6.42,57.558,57.558,0,0,1,9.02-4.239c1.191-.452,2.161-.8,2.837-1.022a4.214,4.214,0,0,1,1.069-.3,4.331,4.331,0,0,1-.991.5l-2.768,1.185a72.931,72.931,0,0,0-8.881,4.351,31.948,31.948,0,0,0-7.612,6.2C769.905,375.192,769.149,376.585,769.062,376.532Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M755.724,376.273a5.6,5.6,0,0,1,.509-1.17c.362-.736.9-1.8,1.618-3.077a29.273,29.273,0,0,1,2.9-4.292,13.514,13.514,0,0,1,2.2-2.182c.887-.6,1.821-1.16,2.786-1.733A76.835,76.835,0,0,1,776,358.7a30.092,30.092,0,0,1,3.3-1.106,5.654,5.654,0,0,1,1.26-.225c.023.094-1.743.5-4.413,1.695A97.685,97.685,0,0,0,766.02,364.3c-.957.568-1.9,1.128-2.76,1.7a13.631,13.631,0,0,0-2.119,2.064,32.3,32.3,0,0,0-2.951,4.16l-1.766,2.98A5.681,5.681,0,0,1,755.724,376.273Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M739.67,212.319c-2.795,10.082-7.738,17.8-9.881,17.211,0,0,1.51-6.42,3.523-16.686,2.336-11.91,2.667-20.308,7.54-19.856C743.067,193.194,742.466,202.237,739.67,212.319Z",
    fill: "#f7eae8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M654.171,212.319c2.8,10.082,7.439,17.869,9.582,17.275,0,0-2.28-8.317-3.635-17.056-1.859-11.994-2.256-20-7.129-19.55C650.774,193.194,651.375,202.237,654.171,212.319Z",
    fill: "#f7eae8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M739.67,212.319c-2.795,10.082-7.738,17.8-9.881,17.211,0,0,1.51-6.42,3.523-16.686,2.336-11.91,2.667-20.308,7.54-19.856C743.067,193.194,742.466,202.237,739.67,212.319Z",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.257
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M654.171,212.319c2.8,10.082,7.439,17.869,9.582,17.275,0,0-2.28-8.317-3.635-17.056-1.859-11.994-2.256-20-7.129-19.55C650.774,193.194,651.375,202.237,654.171,212.319Z",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.257
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M729.789,229.53c-8.86,29.116-33.051,29.6-33.051,29.6s-25.552-.068-33.187-30.3c-5.038-19.946-17.16-50.491-2.627-73.128,8.225-12.811,68.026-17.931,75.07,0S734.984,212.456,729.789,229.53Z",
    fill: "#f7eae8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M704.815,235.08c.644-.216-1.343-3-8.548-3.034-6.114-.026-9.178,2.5-8.625,2.878.685.466,3.121.151,8.378.151S704.113,235.316,704.815,235.08Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M696.27,231.9c6.271.026,8.349,2.011,8.7,2.409.186.209.565.714.072.88h0a15.918,15.918,0,0,1-3.775.1c-1.382-.032-3.1-.072-5.249-.072-1.8,0-3.265.037-4.445.067-2.375.06-3.681.093-4.241-.289-.334-.228.136-.719.688-1.1a15.027,15.027,0,0,1,8.156-1.99Zm-4.74,3.1c1.19-.03,2.67-.068,4.49-.068,2.168,0,3.9.04,5.29.072a22.894,22.894,0,0,0,3.247-.025c.092-.118-.142-.642-1.055-1.219s-3.073-1.552-7.239-1.57h-.087a13.987,13.987,0,0,0-7.31,1.7c-.84.525-.993.9-.916.964a3.78,3.78,0,0,0,1.608.184C690.094,235.035,690.753,235.018,691.53,235Z",
    fill: "#253137"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M696.776,219.566a5.356,5.356,0,0,1-2.115-6.411c1-2.951,1.134-8.6,1.135-8.659l1.085.024c-.005.238-.142,5.874-1.192,8.983a4.272,4.272,0,0,0,1.721,5.181Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M658.192,209.3s-5.115-20.262-6.026-30.494-1.987-23.973,9.542-28.652,7.984,9.607,7.984,9.607-9.118,6.131-10.941,21.485C657.76,189.585,658.192,209.3,658.192,209.3Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M734.826,208.992s5.674-19.956,6.586-30.188,1.987-23.973-9.543-28.652-7.983,9.607-7.983,9.607,9.117,6.131,10.941,21.485C735.818,189.585,734.826,208.992,734.826,208.992Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M725.411,164.672s-14.045,2.239-23.457-2.184c-2.756-1.3-16.135,4.4-22.283,3.248-11.771-2.2-16.94-11.78-17.172-12.765-.678-2.883-3.495-6.99,5.015-13.372,11.771-8.829,26.289-6.687,28.72-9.27s4.875-4.163,9.574-3.693c12.612,1.262,13.23,8.662,20.324,9.771,9.232,1.444,12.347,5.167,12.947,12.917C740.219,164.071,725.411,164.672,725.411,164.672Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M698.666,128.353s-3.951,2.837-13.879,14.386-15.095,10.84-16.21,11.042c0,0,8.568,1.479,17.628-10.434S698.666,128.353,698.666,128.353Z",
    fill: "#949494"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M714.242,164.292s16.563,1.957,23.781-6.7c0,0-1.519,9.05-23.4,6.847Z",
    fill: "#949494"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M687,164.534c-19.518,2.729-25.129-13.381-25.035-13.083,3.075,9.774,10.845,13.539,16.53,15a25.7,25.7,0,0,0,5.082.867c.919.072,1.486.07,1.486.07l.035-.009c18.665.162,33.776-19.576,33.776-19.576C706.209,158.706,694.972,162.963,687,164.534Z",
    fill: "#949494"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M684.988,209.552l6.449-6.449v6.449Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M676.691,209.552l-3.38-3.38v-8.3l6.449-6.449h8.3l3.38,3.38v8.3l-6.449,6.449Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M679.76,191.426l-6.449,6.449v-6.449Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M714.43,210.124l6.449-6.449v6.449Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M706.133,210.124l-3.38-3.38v-8.3L709.2,192h8.3l3.38,3.38v8.3l-6.449,6.449Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M709.2,192l-6.449,6.449V192Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M720.309,188.953A10.988,10.988,0,0,0,712.3,187a1.778,1.778,0,0,1-1.961-2.182h0a1.772,1.772,0,0,1,1.169-1.3,10.472,10.472,0,0,1,11.149,2.616,1.755,1.755,0,0,1,.415,1.623l-.027.116A1.78,1.78,0,0,1,720.309,188.953Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 0.836,
    cy: 0.811,
    rx: 0.836,
    ry: 0.811,
    transform: "translate(710.99 200.784)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M682.374,200.619a.811.811,0,1,0,.835.811A.824.824,0,0,0,682.374,200.619Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M720.183,198.257a8.778,8.778,0,0,0-17.046,1.353l-.009.005a8.287,8.287,0,0,0-12.09-.476,8.789,8.789,0,0,0-17.021-1.1c-14.665-5.2-18.278-5.877-19.247-5.7-.29.054-.537.489-.585.729l.756.306a1.35,1.35,0,0,1,.15-.19c1.274-.147,10.392,2.819,18.649,5.74a8.8,8.8,0,0,0,16.252,6.194,2.484,2.484,0,0,0,.748-.252,2.357,2.357,0,0,0,.683-.51,2.789,2.789,0,0,0,.689-1.5,4.245,4.245,0,0,0-.516-2.955,7.35,7.35,0,0,1,10.9.389,4.424,4.424,0,0,0-.409,2.782,2.787,2.787,0,0,0,.69,1.495,2.34,2.34,0,0,0,.683.51,2.519,2.519,0,0,0,.749.253,8.8,8.8,0,0,0,16.251-6.195c8.383-2.968,17.489-6,18.527-5.745-.034-.009.938-.385.938-.385C739.633,192.4,739.237,191.507,720.183,198.257Zm-37.81,10.384a7.894,7.894,0,1,1,7.894-7.893A7.9,7.9,0,0,1,682.373,208.641Zm8.8-5.332a1.621,1.621,0,0,1-.378.52,1.422,1.422,0,0,1-.219.133,8.767,8.767,0,0,0,.6-2.946,1.861,1.861,0,0,1,.188.517A3.734,3.734,0,0,1,691.171,203.309Zm12.236.737a1.632,1.632,0,0,1-.378-.52,3.739,3.739,0,0,1-.19-1.777,1.837,1.837,0,0,1,.188-.518,8.757,8.757,0,0,0,.6,2.948A1.561,1.561,0,0,1,703.407,204.046Zm8.419,4.81a7.893,7.893,0,1,1,7.893-7.893A7.9,7.9,0,0,1,711.826,208.856Z",
    fill: "#302420"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M673.891,188.737a10.988,10.988,0,0,1,8.013-1.953,1.778,1.778,0,0,0,1.96-2.182h0a1.769,1.769,0,0,0-1.168-1.3,10.472,10.472,0,0,0-11.149,2.616,1.761,1.761,0,0,0-.416,1.623l.028.115A1.78,1.78,0,0,0,673.891,188.737Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M747.172,263.055l37.334,20.29s30.386,17.728,23.852,100.3",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.018
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOops);
export default __webpack_public_path__ + "static/media/oops.eae2072d02351aa2dbcb47ed42dc791f.svg";
export { ForwardRef as ReactComponent };